import {
	LogSystemApi,
	type LogEventInput,
} from "@utils/api/analytics/log-system.api";
import { WallpaperWebApi } from "@utils/api/wallpaper/web-client.api";
import type { UserLoginPageDTO } from "@utils/api/analytics/user-event.dto";

import { getStoredFrom, isLiffFlow } from "./wallpaperParams";

const nowSec = () => Math.floor(Date.now() / 1000);

/**
 * 桌布活動的數據上報：上報內容兩版相同，只有打的 API 不同。
 *  - 台灣 LIFF 版：log system（/liff/login 換來的 log_token）
 *  - 國際 web 版：主 API 的 /log/page、/log/event（web-client 的 access_token）
 *
 * 兩個函式都不會拋錯（含換 token 失敗）：數據掛掉不能影響活動流程，
 * 所以呼叫端不必 try/catch、也不必接 .catch()。
 * 回傳值代表這次是否上報成功，目前只有登入 Guard 用它判斷 token 是否還有效。
 */
async function send(
	label: string,
	request: () => Promise<unknown>,
): Promise<boolean> {
	try {
		await request();
		return true;
	} catch (error) {
		console.warn(`[wallpaper-log] ${label} 上報失敗（已忽略）`, error);
		return false;
	}
}

/** 頁面瀏覽上報。 */
export function logWallpaperPage(
	data: Omit<UserLoginPageDTO, "ts">,
): Promise<boolean> {
	const payload: UserLoginPageDTO = { ...data, ts: nowSec() };
	return send("page", () =>
		isLiffFlow()
			? LogSystemApi.logPage(payload)
			: WallpaperWebApi.logPage(payload),
	);
}

/** 事件上報：自動帶上來源 from（liff / 國家代碼 / 預設 hk），各頁不必自己塞。 */
export function logWallpaperEvent(
	data: Omit<LogEventInput, "ts" | "from">,
): Promise<boolean> {
	const payload: LogEventInput = {
		...data,
		from: getStoredFrom(),
		ts: nowSec(),
	};
	return send("event", () =>
		isLiffFlow()
			? LogSystemApi.logEvent(payload)
			: WallpaperWebApi.logEvent(payload),
	);
}
